import { useGetBtcPriceQuery } from 'modules/common/actions/getBtcPrice';
import { ACTION_CACHE_LONG, ZERO } from 'modules/common/const';
import { formatBigNumberShort } from 'modules/common/utils/formatBigNumber';
import { useGetLbtcVaultSupplyQuery } from 'modules/dashboard/actions/getLbtcVaultSupply';
import { useTranslation } from 'modules/i18n';
import { StatsBlock } from '../StatsBlock';
import { translation } from './translation';

export function VaultTvl(): JSX.Element {
  const { t, keys } = useTranslation(translation);

  const { data: btcPrice = 0, isLoading: isBtcPriceLoading } =
    useGetBtcPriceQuery(undefined, {
      refetchOnMountOrArgChange: ACTION_CACHE_LONG,
    });

  const { data: lbtcSupply = ZERO, isLoading: isLbtcSupplyLoading } =
    useGetLbtcVaultSupplyQuery(undefined, { pollingInterval: 15_000 });

  const usdTvl = lbtcSupply.multipliedBy(btcPrice);
  const formattedUsdTvl = formatBigNumberShort(usdTvl);

  const usdText = t('unit.usdValue', {
    value: formattedUsdTvl,
  });

  const tvlText = t(keys.tvlLabel, {
    value: formatBigNumberShort(lbtcSupply, 2),
  });

  return (
    <StatsBlock
      title={t(keys.title)}
      mainValue={usdText}
      value={tvlText}
      isLoading={isBtcPriceLoading || isLbtcSupplyLoading}
    />
  );
}
